import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

@Pipe({
    name: 'formatTime',

    // WARN: Use with caution!
    // Use this if the pipe should be called on value changed.
    // pure: false,
})
export class FormatTimePipe implements PipeTransform {
    public transform(time: string, format: string = 'HH:mm'): string {
        if (!time) {
            return 'N/A';
        }

        if (!this.isValidTimeFormat(time)) {
            console.warn(`Invalid time format for ${time}`);
            return 'N/A';
        }

        const [hours, minutes, seconds] = time.split(':').map(part => parseInt(part, 10) || 0);
        const date = new Date();
        date.setHours(hours, minutes, seconds, 0);

        const options: Intl.DateTimeFormatOptions = this.getFormatOptions(format);
        return new Intl.DateTimeFormat('en-US', options).format(date);
    }

    private isValidTimeFormat(time: string): boolean {
        const validFormats = [
            'HH:mm',
            'HH:mm:ss',
            'HH:mm:ss:sss',
            'HH:mm a',
            'HH:mm:ss a',
            'HH:mm:ss:sss a',
            'HH:mm A',
            'HH:mm:ss A',
            'HH:mm:ss:sss A',
        ];

        return dayjs(time, validFormats, true).isValid();
    }

    private getFormatOptions(format: string): Intl.DateTimeFormatOptions {
        const options: Intl.DateTimeFormatOptions = {};

        // Mapping the format string to Intl.DateTimeFormat options
        if (format.includes('hh') || format.includes('HH')) {
            options.hour = '2-digit';
        } else if (format.includes('h') || format.includes('H')) {
            options.hour = 'numeric';
        }

        if (format.includes('mm')) {
            options.minute = '2-digit';
        } else if (format.includes('m')) {
            options.minute = 'numeric';
        }

        if (format.includes('ss')) {
            options.second = '2-digit';
        } else if (format.includes('s')) {
            options.second = 'numeric';
        }

        options.hour12 = format.includes('a');

        return options;
    }
}
